import { Food } from "../../models/Food";
import { Tab } from "../components/tab-nav";
import { WaterLog } from "./water-intake-dashboard/types";

export const queryKey = {
    meals: (date: string) => ["foods", "meals", date],
    nutritionDetails: (date: string) => ["foods", "nutrition_details", date],
    meal: (id: string) => ["foods", "meal", id],
    waterReminders: () => ["foods", "water_reminders"],
    foodBudget: (date: Date) => ["foods", "budgets", date],
    allFood: () => ["foods", "all"],
    waterTarget: (date: string) => ["foods", "water_target", date],
    waterintakeEnabled: () => ["water_intake", "enabled"],
    waterLogs: (date: string) => ["foods", "water_logs", date],
    frequentFood: () => ["foods", "frequent"],
    customFoods: () => ["foods", "custom"],
    customFood: (id: string) => ["foods", "custom", id],
    foodTarget: (date: Date) => ["foods", "targets", date],
    favoriteFoods: () => ["foods", "favorites"],
    foodGroups: () => ["foods", "groups"],
    foodGroup: (id: string) => ["foods", "group", id],
    foodGroupingEnabled: () => ["foods", "group", "enabled"],
};

export type Unit = "ml" | "oz" | "";
export const tabKeys = ["All", "Frequent", "My Meals", "Favorites", "Custom"];
export const tabs: Tab[] = tabKeys.map((tab) => ({ name: tab, key: tab }));

export const ADD_MEAL_TYPE_KEY = "add-food-meal-type";
export const ADD_DATE_KEY = "add-food-date";
export const ADD_FOOD_KEY = "add-food";
export const NUTRIENT_LOADED_KEY = "add-food-nutrient-loaded";
export const FOODS_DASHBOARD_DATE = "foods-dashboard-date";

export type MealType = "BREAKFAST" | "LUNCH" | "DINNER" | "SNACKS";
export const mealTypeTabs = [
    { name: "BREAKFAST" },
    { name: "LUNCH" },
    { name: "DINNER" },
    { name: "SNACKS" },
];

export interface FavoriteFood {
    id: string;
    food: Food;
    type: string;
    metadata: Recipe;
    ai_meal_id: string;
}

export interface Meal {
    id: string;
    meal_type: MealType;
    food: Food;
    date: string;
    quantity: number;
    serving_unit: string;
    calories: number;
    protein: number;
    carbs: number;
    sodium: number;
    fat: number;
    serving_qualifier: number;
}

export interface RecipeResult {
    from: number;
    to: number;
    more: boolean;
    count: number;
    hits: Hit[];
    next?: string;
}

export interface Hit {
    recipe: Recipe;
}

export interface Recipe {
    uri: string;
    label: string;
    image: string;
    calories: number;
    yield: number;
    source: string;
    url: string;
    images: {
        THUMBNAIL: {
            url: string;
        };
    };
    totalNutrients: { [id: string]: Nutrient };
    dietLabels: string[];
    healthLabels: string[];
    cautions: string[];
    ingredientLines: string[];
    ingredients: {
        text: string;
        quantity: number;
        measure: string;
        food: string;
    }[];
}

interface Nutrient {
    label: string;
    quantity: number;
    unit: string;
}

export interface FoodSearchResult {
    common: Food[];
    branded: Food[];
    gaurd?: string;
}

export interface AddParams {
    mealType: MealType;
    date: string;
}

export interface MealSubmitData {
    mealType: MealType;
    date: string;
    food: Food;
    quantity: number;
    servingUnit: string;
}

export interface CustomFoodSubmitData {
    food_name: string;
    serving_unit: string;
    serving_qty: string;
    nf_calories: string;
    nf_total_fat: string;
    nf_saturated_fat: string;
    nf_cholesterol: string;
    nf_sodium: string;
    nf_total_carbohydrate: string;
    nf_dietary_fiber: string;
    nf_sugars: string;
    nf_protein: string;
    calcium: string;
    vitamin_a: string;
    vitamin_c: string;
    vitamin_d: string;
    iron: string;
    phosphorus: string;
    nf_potassium: string;
}

export interface FoodBudget {
    calorie_budget: number;
    protein_budget: number;
    carbs_budget: number;
    fat_budget: number;
    sodium_budget: number;
    cholestrol: number;
    mono_unsaturated_fat: number;
    poly_unsaturated_fat: number;
    saturated_fat: number;
    sugar: number;
}
export interface PieData {
    value: number;
    svg: { fill: string };
    key: string;
}

export interface FoodTargetRemote {
    calorie_target: number;
    carb_percentage: number;
    fat_percentage: number;
    protein_percentage: number;
}

export interface FoodTargetResult {
    calorieTarget: number;
    carbPercentage: number;
    fatPercentage: number;
    proteinPercentage: number;
    carbsGram: number;
    proteinGram: number;
    quantity: number;
    fatGram: number;
}

export interface WaterTarget {
    quantity: number;
    unit: "ml" | "oz" | "";
}

export interface Target extends WaterTarget {
    total_logged: number;
    target_met: boolean;
}

export interface WaterTargetResult {
    status: "success" | "error";
    date: string;
    target: Target;
}

export interface WaterLogResult {
    status: "success" | "error";
    water_intakes: WaterLog[];
    total_logged: number;
}

export interface FoodGroup {
    id: string;
    image_url: string;
    name: string;
    total_calories: number;
    food_count: number;
    foods: FoodGroupFood[];
}

export interface FoodGroupFood {
    id?: string;
    food: Food;
    quantity: number;
    serving_unit: string;
}

export interface FoodGroupImage {
    name: string;
    type: string;
    uri: string;
    file: File | null;
}
